import React from "react";
import { Box, Typography } from "@mui/material";

const titleSx = { mt: 3, mb: 1, fontWeight: 700 };
const labelSx = { width: "200px", fontWeight: 700, flexShrink: 0 };
const valueSx = {
  flex: 1,
  borderBottom: "1px solid #999",
  minHeight: "20px",
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
};
const rowSx = { display: "flex", gap: 2, mb: 1.2, alignItems: "flex-start" };

const valueOrEmpty = (value) => value ?? "";

const fileName = (file) => {
  const path = typeof file === "string" ? file : file?.elimination_path;
  return path ? path.split("/").pop() : "";
};

const Comp20PDF = ({ formData }) => {
  if (!formData) return null;

  const submission = formData.o20?.[0] ?? formData;
  const statuses = [
    submission.o20_status,
    formData.o20_status,
    submission.exhibitor_status,
    submission.host_status,
    submission.corporate_status,
  ];
  const isNoApply = statuses.includes("申請しない");
  const files = Array.isArray(submission.elimination_pathes)
    ? submission.elimination_pathes.map(fileName).filter(Boolean)
    : [];

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        暴力団排除誓約書
      </Typography>

      <Box sx={rowSx}>
        <Typography sx={labelSx}>小間番号</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.booth_number ?? formData.booth_number)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>出展者名</Typography>
        <Box sx={valueSx}>{valueOrEmpty(submission.company_name ?? formData.company_name)}</Box>
      </Box>
      <Box sx={rowSx}>
        <Typography sx={labelSx}>申請状態</Typography>
        <Box sx={valueSx}>{isNoApply ? "申請しない" : "申請する"}</Box>
      </Box>

      {!isNoApply && (
        <>
          <Typography sx={titleSx}>担当者情報</Typography>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>氏名</Typography>
            <Box sx={valueSx}>{valueOrEmpty(submission.user_20_name)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>部署</Typography>
            <Box sx={valueSx}>{valueOrEmpty(submission.user_20_department)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>会社電話番号</Typography>
            <Box sx={valueSx}>{valueOrEmpty(submission.user_20_phone)}</Box>
          </Box>
          <Box sx={rowSx}>
            <Typography sx={labelSx}>携帯電話番号</Typography>
            <Box sx={valueSx}>{valueOrEmpty(submission.user_20_tel)}</Box>
          </Box>

          <Typography sx={titleSx}>アップロード済み誓約書</Typography>
          <Box sx={valueSx}>{files.length > 0 ? files.join("\n") : "未アップロード"}</Box>

          <Typography sx={titleSx}>備考</Typography>
          <Box sx={valueSx}>{valueOrEmpty(submission.alfa_text)}</Box>
        </>
      )}
    </Box>
  );
};

export default Comp20PDF;